module.exports = __webpack_public_path__ + "static/media/chair.42fd5cb6.svg";